export default {
  data() {
    return {
      kind_options: [
        {text: 'Item', value: 'item', icon: 'mdi-shape', color: '#56AEFF'},
        // {text: 'Aprovação', value: 'approval', icon: 'mdi-thumbs-up-down', color: '#FF7085'},
        // {text: 'Formulário', value: 'form', icon: 'mdi-file-document-edit', color: '#96D032'},
        {text: 'Divisor', value: 'divisor', icon: 'mdi-minus', color: '#FFC54D'},
      ],
      kind_text_map: {
        form: {
          icon: 'mdi-file-document-edit',
          text: 'Formulário',
          color_selected: '#96D032',
        },
        item: {
          icon: 'mdi-shape',
          text: 'Item',
          color_selected: '#56AEFF',
        },
        approval: {
          icon: 'mdi-thumbs-up-down',
          text: 'Aprovação',
          color_selected: '#FF7085',
        },
        divisor: {
          icon: 'mdi-minus',
          text: 'Divisor',
          color_selected: '#FFC54D',
        },
        undefined: {
          icon: 'mdi-help',
          text: 'Indefinido',
          color_selected: '#FF7085',
        },
      }
    };
  },
}